import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Error } from 'medication_service_ui';
import ClinicalMedicationList from './clinical-medication-list';
import '../styles.scss';

class ClinicalMedication extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fetched:      false,
      clinicalMeds: [],
      errors:       {}
    };
  }

  componentDidMount() {
    const { memberId } = this.props.memberParams;
    this.props.fetchClinicalMedications({ memberId });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.clinicalMeds !== nextProps.clinicalMeds) {
      this.setState({
        clinicalMeds: nextProps.clinicalMeds
      });
    }
  }

  render() {
    const { fetched, clinicalMeds, errorMessage } = this.props;

    if (errorMessage) {
      return (
        <Error message={errorMessage} />
      );
    }

    return (
      <div>
        { fetched &&
          <ClinicalMedicationList
            medicationList={clinicalMeds}
            onSubmit={this.handleSubmit}
          />
        }

      </div>
    );
  }
}

ClinicalMedication.propTypes = {
  fetched:            PropTypes.bool,
  isLoading:          PropTypes.bool,
  errorMessage:       PropTypes.string,
  clinicalMeds:       PropTypes.array,
  validation:         PropTypes.object,
  memberParams:       PropTypes.shape({
    memberId:  PropTypes.number.isRequired
  }),
  fetchClinicalMedications:        PropTypes.func.isRequired
};

export default ClinicalMedication;
